import { Mail, MapPin, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const footerLinks = {
  capabilities: [
    { name: 'AI Workflow Automation', href: '/capabilities?section=workflow-automation' },
    { name: 'Executive AI Assistants', href: '/capabilities?section=executive-assistants' },
    { name: 'Enterprise RAG & Knowledge', href: '/capabilities?section=rag-knowledge' },
    { name: 'AI Marketing Intelligence', href: '/capabilities?section=marketing-intelligence' },
    { name: 'FinTech & Regulatory AI', href: '/capabilities?section=fintech-regulatory' },
    { name: 'Pharma Knowledge & Compliance AI', href: '/capabilities?section=pharma-compliance' },
    { name: 'Cloud-Native Enterprise Platforms', href: '/capabilities?section=cloud-platforms' },
  ],
  industries: [
    { name: 'Recruitment', href: '/industries?section=recruitment' },
    { name: 'FinTech', href: '/industries?section=fintech' },
    { name: 'Pharma', href: '/industries?section=pharma' },
    { name: 'IT Platform Engineering & DX', href: '/industries?section=platform-engineering' },
    { name: 'Manufacturing', href: '/industries?section=manufacturing' },
  ],
  company: [
    { name: 'About', href: '/about' },
    { name: 'Founding Team', href: '/team' },
    { name: 'Contact', href: '/contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-slate-50 border-t border-slate-200">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Logo & Info */}
          <div className="lg:col-span-2">
            <Link to="/" className="mb-6 inline-block group">
              <img
                src="/images/logo.png"
                alt="CoDriverLabs"
                className="h-32 w-auto transition-transform duration-300 group-hover:scale-105"
              />
            </Link>
            <div className="flex flex-col gap-3 text-slate-600">
              <a
                href="mailto:contact@codriverlabs.ai"
                className="flex items-center gap-2 hover:text-primary transition-colors"
              >
                <Mail className="w-4 h-4" />
                contact@codriverlabs.ai
              </a>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                Dublin, Ireland
              </div>
            </div>
          </div>

          {/* Capabilities */}
          <div>
            <h4 className="text-slate-900 font-semibold mb-4">Capabilities</h4>
            <ul className="space-y-3">
              {footerLinks.capabilities.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-slate-600 hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="text-slate-900 font-semibold mb-4">Industries</h4>
            <ul className="space-y-3">
              {footerLinks.industries.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-slate-600 hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-slate-900 font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-slate-600 hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
            className="border-t border-slate-200 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © 2026 CoDRIVER LABS Limited

          </p>
          <p className="text-slate-500 text-sm">
            Registration Number : 803337

          </p>
          <p className="text-slate-500 text-sm">
            Registration Address : The Pigeons, Athlone, Co Westmeath, Ireland

          </p>
          <div className="flex items-center gap-4">
            <a
                href="#"
                className="text-slate-500 hover:text-primary transition-colors"
                aria-label="LinkedIn"
            >
              <Linkedin className="w-5 h-5"/>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
